import api from "./api";

const getDiocesesByUf = (params) => {
  return api.get(`api/diocese/${params}`);
};

export {
  getDiocesesByUf,
};
